<template>
  <div class="details-table">

    <v-data-table :items="items"
                  hide-default-header
                  hide-default-footer
                  :items-per-page="20"
                  class="no--hover">

      <template v-slot:item="{ item }">
        <tr>
          <td v-if="item.tooltip">
            <v-tooltip top
                       content-class="detailstable-tooltip">
              <span>{{ item.tooltip }}</span>
              <template v-slot:activator="{on}">
                <span v-on="on">{{ item.label }}</span>
              </template>
            </v-tooltip>
          </td>

          <td v-else>{{ item.label }}</td>
          
          <td v-if="item.multiline&&item.value" class="value-data-cell value-data-cell-multiline" pb4>
            <template v-for="(itm,idx) in item.value.split(' ')">
              <div :key="'itm' + idx">{{ itm }}</div>
            </template>
          </td>
          
          <td v-else-if="item.valueTooltip"
              class="value-data-cell">
            <v-tooltip top
                       content-class="detailstable-tooltip">
              <span>{{ item.valueTooltip }}</span>
              <template v-slot:activator="{on}">
                <span v-on="on">{{ getValueText(item) }}</span>
              </template>
            </v-tooltip>
          </td>

          <td v-else
              class="value-data-cell">{{ getValueText(item) }}
          </td>
        </tr>
      </template>

    </v-data-table>

  </div>
</template>
<script>
export default {
  name: "LabelValueTable",
  props: {
    /**
     * Expected format:
     * item.label: label text, places on the left
     * item.tooltip: optional; tooltip text for label
     * item.value: value, placed on the right
     * item.suffix: optional; appended to value
     * item.valueTooltip: optional; tooltip text for value
     */
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    getValueText(item) {
      if (item.suffix) {
        return `${item.value} ${item.suffix}`;
      } else {
        return item.value;
      }
    }
  }
};
</script>
<style>
.details-table {
  width: 100%;
}

.details-table .v-data-table {
  width: 448px;
  max-width: 448px;
  margin: 0 auto;
  display: block;
}

.details-table .v-data-table tr {
  width: 448px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
}

.details-table td {
  font-size: 16px !important;
  height: unset !important;
}

.details-table .value-data-cell {
  text-align: right;
  overflow: hidden;
  word-break: break-all;
}

.details-table .value-data-cell-multiline {
  padding-top: 12px;
  padding-bottom: 12px;
}

.details-table .value-data-cell a {
  display: block;
}

.details-table tr > td:last-child {
  font-weight: 500 !important;
}

.detailstable-tooltip {
  margin-top: -8px !important;
}

</style>
